<div class="normalScreen" style="background:white">
  <form [formGroup]="searchForm" (ngSubmit)="search()">
    <div style="margin-left:10px;margin-top:10px">
      <mat-form-field>
        <input matInput data-cy="fromDate" [matDatepicker]="from" [max]="fromMaxValue()" placeholder="Från" formControlName="from">
        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <input matInput data-cy="toDate" [matDatepicker]="to" [min]="toMinValue()" [max]="maxDate" placeholder="Till" formControlName="to">
        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
        <mat-datepicker #to></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Hållplats</mat-label>
        <mat-select data-cy="busStop" placeholder="Hållplats" formControlName="transfer">
          <mat-option *ngFor="let loc of locations" [value]="loc">
            {{loc.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button mat-flat-button color="primary" data-cy="searchSum" type="submit" style="margin-left:10px;background:#7AB800" [disabled]="!canSearch()">Sök</button>
      <button mat-flat-button color="primary" data-cy="exportSum" type="button" (click)="exportSummary()" style="margin-left:10px;background:#7AB800" [disabled]="!canExport()">Exportera till Excel</button>
    </div>
  </form>
  <div style="margin-left:10px;margin-top:25px" *ngIf="noMatch && performedSearch" class="alert alert-info">
    <label>Hittade inga matchande transfers.</label>
  </div>
  <div width="1600">
    <ngx-spinner #spinner [config]="spinnerConfig">
    </ngx-spinner>
    <div style="margin-left:10px;margin-top:25px;" *ngIf="!noMatch">
      <div height="700" style="position:relative">
        <div style="margin-top:15px">
          <canvas #chart baseChart width="1100" height="500"
                  [datasets]="lineChartData"
                  [labels]="lineChartLabels"
                  [options]="lineChartOptions"
                  [colors]="lineChartColors"
                  [legend]="lineChartLegend"
                  [chartType]="lineChartType"></canvas>
        </div>
      </div>
    </div>

  </div>
</div>
